import { motion } from 'motion/react'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
`

export const CountryContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8};
  cursor: pointer;
  border-radius: ${props => props.theme.primitives.radius.radius2};

  &:hover {
    background-color: ${props => props.theme.colors.disabled.surface};
  }
`

export const CountryPosition = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp16};
  width: ${props => props.theme.size.S};
`

export const CountryInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
`

export const CountryName = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ProgressBar = styled(motion.div)`
  width: 0%;
  height: ${props => props.theme.size.XXS};
  background-color: ${props => props.theme.colors.background.decorative};
  position: relative;
  border-radius: ${props => props.theme.primitives.radius.radius2};
`
